"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueBreadcrumbDto = exports.VenueBreadcrumbAuthorDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const VenueBreadcrumbReactionSummary_dto_1 = require("./VenueBreadcrumbReactionSummary.dto");
class VenueBreadcrumbAuthorDto {}
exports.VenueBreadcrumbAuthorDto = VenueBreadcrumbAuthorDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbAuthorDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueBreadcrumbAuthorDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueBreadcrumbAuthorDto.prototype, "blurredImageUrl", void 0);
class VenueBreadcrumbDto {}
exports.VenueBreadcrumbDto = VenueBreadcrumbDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumbAuthorDto
}), __metadata("design:type", VenueBreadcrumbAuthorDto)], VenueBreadcrumbDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumbReactionSummary_dto_1.VenueBreadcrumbReactionSummaryDto,
  isArray: true
}), __metadata("design:type", Array)], VenueBreadcrumbDto.prototype, "reactions", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], VenueBreadcrumbDto.prototype, "isAuthor", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueBreadcrumbDto.prototype, "replyCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Null when the note is kept on the author\'s profile (never expires).'
}), __metadata("design:type", Object)], VenueBreadcrumbDto.prototype, "expiresAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], VenueBreadcrumbDto.prototype, "keepOnProfile", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Number of ❤️ reactions.'
}), __metadata("design:type", Number)], VenueBreadcrumbDto.prototype, "likeCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], VenueBreadcrumbDto.prototype, "likedByMe", void 0);
//# sourceMappingURL=VenueBreadcrumb.dto.js.map